import React, { useEffect } from "react";
import KickImage from 'Reuseables/KickImage';

const VoucherCard = ({
  item,
  minPurchase,
  validUntilText,
  openModalDetail,
  setDetailVoucher,
  voucherName,
  bottomRight,
  bottomLeft,
  voucherStatus,
  image,
  history
}) => {
  return (
    <div
      className={`dashboard-voucher-card ${history ? "history" : ""}`}
      onClick={() => openModalDetail()}
    >
      <div className="top-wrapper">
        <div className="img-wrapper">
          <KickImage src={image} alt="..." />
        </div>
        <div className="description-wrapper">
          <p>{voucherName}</p>
          { history ?
            (
              <>
                <p>Min purchase <span>{minPurchase}</span></p>
                <p>Valid until <span>{validUntilText}</span></p>
              </>
            ) 
            :
            (
            <>
              <p>Min purchase <span>{minPurchase}</span></p>
              <p>Valid until <span>{validUntilText}</span></p>
            </>
            )
          }
        </div>
      </div>
      <div className={`bottom-wrapper ${history ? "history" : ""}`}>
        <p>{bottomLeft}</p>
        <p>{bottomRight}</p>
      </div>
    </div>
  )
}

export default VoucherCard